import { useIframeModeStore } from '@/hooks/useIframeModeStore';

/** How the user reached SMP — distinct from the purchase/billing platform. */
export type AccessChannel = 'native-app' | 'mobile-web' | 'desktop-web';

/**
 * Access-channel context for Sentry logs. Reads the iframe store via getState()
 * so it works outside React (e.g. inside the mutation-error logger) and is
 * stable across client-side navigation (the query params may drop, the store
 * value persists).
 *
 * - `in_iframe=true` (only Viome-mfe sets it) → native app webview
 * - otherwise a browser: split into mobile-web / desktop-web by user agent
 *
 * `os` is the host's Platform.OS ('ios' | 'android') for native loads, empty
 * for browser loads (the channel already distinguishes those).
 */
export const getAccessContext = (): { accessChannel: AccessChannel; os: string } => {
  const { isIframeMode, os } = useIframeModeStore.getState();
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const accessChannel: AccessChannel = isIframeMode
    ? 'native-app'
    : /Mobi|Android|iPhone|iPad|iPod/i.test(ua)
      ? 'mobile-web'
      : 'desktop-web';
  return { accessChannel, os };
};
